import React, {useEffect} from 'react';
import styled, {keyframes} from 'styled-components';
import theme from './../theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
 
const ContenedorAlerta = styled.div`
    z-index: 1000;
    width: 100%;
    left: 0;
    top: 1.25rem; /* 20px */
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${fadeIn} 0.3s ease;
 
    p {
        background: ${(props) => {
            if(props.tipo === 'error'){
                return 'rgba(227, 71, 71, 0.9)';
            } else if (props.tipo === 'exito') {
                return 'rgba(67, 168, 84, 0.9)';
            } else {
                return 'rgba(0,0,0,0.8)';
            }
        }};
        backdrop-filter: blur(10px);
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        color: #fff;
        padding: 1.25rem 2.5rem; /* 20px 40px */
        border-radius: 0.31rem; /* 5px */
        box-shadow: 0px 0px 15px rgba(0,0,0,.1);
        text-align: center;
    }
`;

const Alerta = ({tipo, mensaje, estadoAlerta, cambiarEstadoAlerta}) => {
	useEffect(() => {
		let tiempo;

		if(estadoAlerta === true){
			tiempo = setTimeout(() => {
				cambiarEstadoAlerta(false);
			}, 4000);
		}

		// Pasamos una funcion de limpieza. Esta funcion se ejecuta si el componente se desmonta.
		// Lo que hacemos es limpiar el tiempo para que no intente cambiar el estado si el componente no esta en pantalla.
		// Es importante para poder cambiar de componentes en pantalla sin errores.
		return(() => clearTimeout(tiempo));
	}, [estadoAlerta, cambiarEstadoAlerta]);

	return (
		<>
			{estadoAlerta &&
				<ContenedorAlerta tipo={tipo}>
					<p>{mensaje}</p>
				</ContenedorAlerta>
			}
		</>
	);
}
 
export default Alerta;